export { default } from './altyn-bank';
